import { render } from "./FloatComponent.vue?vue&type=template&id=323a40d4&scoped=true"
import script from "./FloatComponent.vue?vue&type=script&lang=js"
export * from "./FloatComponent.vue?vue&type=script&lang=js"

import "./FloatComponent.vue?vue&type=style&index=0&id=323a40d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323a40d4"]])

export default __exports__